import styled from 'styled-components';
import Image from '@components/Image';

const StyledImage = styled.div`
  width: 38px;
  height: 38px;
  border: ${({ theme }) => `1px solid ${theme.colors.platinum}`};
  border-radius: 6px;
  ${Image} {
    border: none;
  }
`;

export default StyledImage;
